import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'EL LIBRO DE ORO DE LOS INFORMES PSICOPEDAGÓGICOS',
    desc: 'Informes de diagnóstico, evolución, escuela, PPI, CUD, alta y derivación · Banco de frases pre-redactadas · Checklist de calidad.',
    value: '$10.000'
  }, {
    num: '02',
    title: 'KIT DE ENTREVISTAS CON ESCUELAS',
    desc: 'Protocolo de contacto institucional · Guiones para docentes, EOE/APOE y directivos · Cartas y notas · Informe de reunión · Seguimiento post-reunión.',
    value: '$9.000'
  }, {
    num: '03',
    title: 'GUÍA DE ORIENTACIÓN A PADRES',
    desc: 'Primera sesión de orientación · Guías por diagnóstico (TDAH, Dislexia, Discalculia) · Emociones y autoestima · Acompañamiento escolar · Seguimiento trimestral.',
    value: '$9.000'
  }, {
    num: '04',
    title: 'GESTIÓN DEL CONSULTORIO ADMIN PRO',
    desc: 'Calculadora de honorarios · Contrato terapéutico · Planillas de registro y asistencia · Protocolo de cancelaciones · Facturación · Gestión de OS · Checklist mensual.',
    value: '$9.000'
  }, {
    num: '05',
    title: 'PLANTILLAS DE DERIVACIÓN A OTROS PROFESIONALES',
    desc: 'Derivaciones a Neuro, Psicología, Fono, Psiquiatría y TO · Informe interdisciplinario · 3 modelos de alta · Protocolo de comunicación · Registro por paciente.',
    value: '$8.000'
  }, {
    num: '06',
    title: 'MARCO LEGAL Y ÉTICO ARGENTINA 2026',
    desc: 'Leyes 26.206, 24.901, 26.657 y 26.061 aplicadas · Secreto profesional · Consentimiento informado · Ética · Obligación de denuncia · Habilitación y matriculación.',
    value: '$8.000'
  }];
  return <section className="py-20 px-4 bg-brand/5 border-y border-brand/20 pt-[25px] pb-[25px]" data-id="element-53">
      <div className="max-w-6xl mx-auto" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <div className="inline-flex items-center space-x-2 bg-brand text-white px-6 py-2 rounded-full mb-6 font-bold shadow-[0_0_20px_rgba(59,130,246,0.4)]" data-id="element-56">
            <Gift className="w-5 h-5" data-id="element-57" />
            <span data-id="element-58">SIEMPRE INCLUIDOS</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black" data-id="element-59">
            🎁 MÁS LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-gray-400 mt-4 mb-[-29px]" data-id="element-60">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-61">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-6 relative overflow-hidden group hover:border-brand transition-colors" data-id="element-62">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-white/5 group-hover:text-brand/5 transition-colors" data-id="element-63">
                {bonus.num}
              </div>
              <div className="relative z-10" data-id="element-64">
                <div className="text-brand font-bold mb-2" data-id="element-65">
                  Bono {bonus.num}
                </div>
                <h4 className="text-lg font-bold mb-3 text-white leading-tight" data-id="element-66">
                  {bonus.title}
                </h4>
                <p className="text-gray-400 text-sm mb-6" data-id="element-67">{bonus.desc}</p>
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-dark-border" data-id="element-68">
                  <span className="text-gray-500 line-through text-sm" data-id="element-69">
                    Valor {bonus.value}
                  </span>
                  <span className="text-brand font-black" data-id="element-70">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-brand/20 to-brand/5 border border-brand/30 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-71">
          <div className="text-gray-300 mb-2" data-id="element-72">Valor total de los 6 bonos</div>
          <div className="flex items-center justify-center space-x-4" data-id="element-73">
            <span className="text-3xl text-gray-500 line-through font-bold" data-id="element-74">
              $53.000
            </span>
            <span className="md:text-4xl font-black text-brand text-[26px]" data-id="element-75">
              → GRATIS
            </span>
          </div>
          <div className="text-sm text-gray-400 mt-2" data-id="element-76">
            ✅ Incluidos siempre en las dos ofertas
          </div>
        </motion.div>
      </div>
    </section>;
}